const rhAssessor = () => import(/* webpackChunkName: "rhAssessor" */ "@/views/rhAssessor/RHAssessor");
const rhAssessorList = () => import(/* webpackChunkName: "rhAssessor List" */ "@/views/rhAssessor/RHAssessorList");
const rhAssessorEdit = () => import(/* webpackChunkName: "rhAssessor Edit" */ "@/views/rhAssessor/RHAssessorEdit");

const rhAssessorRoutes = [
  {
    path: "rhAssessor",
    name: "RH Assessor",
    redirect: {
      name: "RH Assessor List"
    },
    component: rhAssessor,
    children: [
      {
        path: "list",
        name: "RH Assessor List",
        component: rhAssessorList
      },
      {
        path: "edit/:id",
        name: "RH Assessor Edit",
        component: rhAssessorEdit,
        props: true
      }
    ]
  }
];

export default rhAssessorRoutes;
